'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $('html').click(function (e) {
    const $target = $(e.target);

    if (!$target.is('.js-nav-menu__trigger')) {
      $('.nav-menu').removeClass('nav-menu--active');
    }
  });

  $(document).on('click', '.js-nav-menu__trigger', function () {
    $(this).closest('.user-nav').find('.nav-menu').toggleClass('nav-menu--active');
    return false;
  });

  $(document).on('click', '.js-mobile-menu', function () {
    $('.header__inner').toggleClass('header__inner--active active');
  });
});
